module.exports = __webpack_public_path__ + "img/JA-Logo-Round-Black-Transparent.f9350b89.png";